module.exports = __webpack_public_path__ + "img/etiquetado4.45b101b1.jpg";